module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"qualifications":{"action":"Qualifikationen hinzufügen","empty_state":"Fügen Sie Ihre erworbenen Qualifikationen hinzu, um Ihre Vertrauenswürdigkeit noch weiter zu steigern.","title":"Qualifikationen"}}}}}}}')
  delete Component.options._Ctor
}
